/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_device_system: 'device/set_device_system',
}

// count state 必須是 Object
const state = {
    system: null,
    androidUrl: {
        tenant: 'https://play.google.com/store/apps/details?id=com.funghouse.flypig',
        landlord: 'https://play.google.com/store/apps/details?id=com.funghouse.flypigsteward',
    },
    iosUrl: {
        tenant: 'itms-apps://itunes.apple.com/app/apple-store/id1519744732',
        landlord: 'itms-apps://itunes.apple.com/app/apple-store/id1550254563'
    }
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_DEVICE_SYSTEM: (state) => {
        return state.system
    },
    GET_APP_URL: (state) => {
        if(state.system == 'ios'){
            return state.iosUrl
        }else if(state.system == 'android'){
            return state.androidUrl
        }
    },
    GET_IOS_URL: (state) => {
        return state.iosUrl
    },
    GET_ANDROID_URL: (state) => {
        return state.androidUrl
    }
    
}

// actions 也是以 Object 形式建構。
const actions = {
    getDeviceSystem ( {commit} ) {
        return new Promise((resolve, reject) => {
            let isIos = !!navigator.userAgent.match(/(iphone|ipod|ios|ipad)/ig)
            let isAndroid = !!navigator.userAgent.match(/android/ig)
            if(isIos){
                commit(types.set_device_system, 'ios');
            }else if(isAndroid){
                commit(types.set_device_system, 'android');
            }else{
                commit(types.set_device_system, 'pc');
            }
            resolve()
        })
    },
}

// mutations
const mutations = {
    [types.set_device_system](state, data){
        state.system = data
    }
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/landlord/device.js